'use client';

import { BookmarkIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';
import type { Bookmark } from '@/types/bookmarks';
import { cn } from '@/utils/ui-utils';
import { Notification } from '../../../Notification';

interface ButtonProps {
  activeBookmark: Bookmark | null;
  dataLength: number;
  className?: string;
}

const BookmarkTrigger = ({
  activeBookmark,
  dataLength,
  className,
  ...rest
}: ButtonProps & React.ComponentProps<'button'>) => {
  return (
    <Button
      className={cn('tablet-lg:h-auto tablet-lg:text-base tablet-lg:p-0 px-0 text-sm font-normal', className)}
      {...rest}
    >
      <BookmarkIcon
        strokeWidth={2}
        className={cn('tablet-lg:h-5 tablet-lg:w-5 h-4 w-4', !!activeBookmark && 'text-highlight')}
      />
      <span className='desktop-area-filter:sr-only laptop-lg:not-sr-only'>Bokmärken</span>
      <Notification value={dataLength} />
    </Button>
  );
};

export default BookmarkTrigger;
